import { LoginError } from '@local/login/components/loginError/LoginError';
import { LOGIN_COOKIES_DISABLED } from '@local/login/strings';
import { Notification, NotificationType } from '@local/web-design-system/components/Notification';
import Grid from '@mui/material/GridLegacy';
import { useEffect } from 'react';

import { getImagoMpApiUrl } from 'src/apiClients';
import { LegacyLoginForm } from 'src/components/login/legacy-form';
import { getIsProduction } from 'src/utils/get-is-production';

import { useStyles } from './LoginForm.styles';

const CookiesDisabledNotification = () => {
    const enabled = window.navigator.cookieEnabled;
    return !enabled ? (
        <Notification type={NotificationType.ERROR} message={LOGIN_COOKIES_DISABLED} />
    ) : null;
};

export const LoginForm = () => {
    const { classes } = useStyles();

    /*
     * In production we don't offer the in-app legacy login form: the
     * AccessTokenGuard sends logged-out users here, so this is where the
     * enterprise SSO hand-off has to happen. Send them straight to the
     * Imago Admin SSO entry point (still the shared `imagoadmin` record).
     */
    const isProduction = getIsProduction();

    useEffect(() => {
        if (isProduction) {
            window.location.replace(`${getImagoMpApiUrl()}enterprise/imagoadmin`);
        }
    }, [isProduction]);

    if (isProduction) {
        return null;
    }

    return (
        <form className={classes.form}>
            <Grid container className={classes.container}>
                <Grid item xs={12} className={classes.error}>
                    <LoginError />
                    <CookiesDisabledNotification />
                </Grid>
                <Grid item xs={12}>
                    <LegacyLoginForm />
                </Grid>
            </Grid>
        </form>
    );
};
